import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InViewModule } from '@teamfoster/sdk/in-view';
import { Image, ImageModule } from '@teamfoster/sdk/image';
import { TextShapeComponent } from '../text-shape/text-shape.component';
import { RouterModule } from '@angular/router';
import { ButtonModule } from '@teamfoster/sdk/button';
import { TestComponent } from '../test/test.component';
import { CarrousselItem } from '../../content-blocks/models/carrousselItem.model';

@Component({
  selector: 'app-workshop-card',
  standalone: true,
  imports: [CommonModule, InViewModule, ImageModule, RouterModule, ButtonModule, TestComponent],
  templateUrl: './workshop.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class workshopCardComponent {
  @Input() item!: CarrousselItem;
  @Input() active = false;

  inview($e: any) {
    // this.moduleInview = $e;
  }
}
